import moment from 'moment/moment';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { cn } from '@shared/utils/helpers';

type DateProps = PropsWithClassName<{
  date?: string | null;
}>;

export function Date({ date, className }: DateProps) {
  if (!date) {
    return null;
  }

  const parsed = moment.utc(date, 'YYYY-MM-DD').local();

  return (
    <time dateTime={date} className={cn(className)}>
      {parsed.format('DD/MM/YYYY')}
    </time>
  );
}
